import { FC } from 'react';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';

import { Announcement, Button } from '../common/ui';

import paySuccessSvg from './assets/PaySuccess.svg';
import payErrorSvg from './assets/PayError.svg';
import payNotFoundSvg from './assets/PayNotFound.svg';

const Info: FC<{
  type: 'error' | 'success' | 'notFound';
}> = ({ type }) => {
  const router = useRouter();
  switch (type) {
    case 'success':
      return (
        <Announcement
          img={paySuccessSvg}
          alt="Оплата проведена успешно"
          heading="Оплата проведена успешно"
        >
          <Button variant="plain" onClick={() => router.push('/')}>
            Вернуться на главную страницу
          </Button>
        </Announcement>
      );
    default:
    case 'error':
      return (
        <Announcement
          img={payErrorSvg}
          alt="Ошибка проведения платежа: попробуйте повторить через 15 минут"
          heading="Ошибка проведения платежа: попробуйте повторить через 15 минут"
        >
          <Button variant="plain" onClick={() => router.push('/')}>
            Вернуться на главную страницу
          </Button>
        </Announcement>
      );
    case 'notFound':
      return (
        <Announcement
          img={payNotFoundSvg}
          alt="Заём не найден. Проверьте данные и повторите попытку "
          heading="Заём не найден. Проверьте данные и повторите попытку "
        >
          <Button variant="plain" onClick={() => router.push('/pay')}>
            Вернуться к началу оплаты
          </Button>
        </Announcement>
      );
  }
};

export const PageInfo = observer(Info);
